// extracted by mini-css-extract-plugin
module.exports = {"divider_container":"TermsPage_divider_container__21dEW","url":"TermsPage_url__2zRtq"};